import { assertNever } from '@kofno/piper';
import clsx from 'clsx';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import Button from '../../../../../Form/Button';
import { ImportedParticipantsResource } from '../../../Store/Types';
import GroupFormState from './GroupFormState';
import ParticipantsForm from './ParticipantsForm';
import AddParticipantsToGroupFormStore from './Store';
import { Ready, ReadyToSubmit } from './Store/Types';

interface Props {
  successfulParticipantsResource: ImportedParticipantsResource;
  addParticipantsToGroupFormStore: AddParticipantsToGroupFormStore;
  state: Ready | ReadyToSubmit;
}

const handleSubmit = (
  state: Ready | ReadyToSubmit,
  addParticipantsToGroupFormStore: AddParticipantsToGroupFormStore,
) => {
  switch (state.kind) {
    case 'ready-to-submit':
      addParticipantsToGroupFormStore.submit();
      break;
    case 'ready':
      break;
    default:
      assertNever(state);
  }
};

const buttonDisabled = (state: Ready | ReadyToSubmit) => {
  switch (state.kind) {
    case 'ready':
      return fromEmpty(state.participants).isJust();
    case 'ready-to-submit':
      return false;
  }
};

function AddParticipantsToGroupForm({
  successfulParticipantsResource,
  addParticipantsToGroupFormStore,
  state,
}: Props) {
  return (
    <>
      <h2 className="mb-2 text-2xl font-semibold">
        <T kind="Add Participants to Group" />
      </h2>
      <p className="mt-2 mb-6 text-sm">
        <T kind="Select the group you want to add the following recipients to" />
      </p>
      <div className="mb-8">
        <GroupFormState
          successfulParticipantsResource={successfulParticipantsResource}
          addParticipantsToGroupFormStore={addParticipantsToGroupFormStore}
          addParticipantsGroupFormState={state}
        />
      </div>
      <p className="flex text-sm font-semibold">
        <T kind="Participants to be added ({{count}} selected)" count={state.participants.length} />
      </p>
      <ParticipantsForm
        addParticipantsToGroupFormStore={addParticipantsToGroupFormStore}
        state={state}
      />
      <Button
        className={clsx(
          'px-10 py-2 mt-8',
          'text-white text-sm text-center',
          'cursor-pointer',
          'rounded-md bg-teal-600',
          'disabled:opacity-50',
          'disabled:cursor-not-allowed',
        )}
        value="Submit"
        type="button"
        disabled={buttonDisabled(state)}
        onClick={() => handleSubmit(state, addParticipantsToGroupFormStore)}
      />
    </>
  );
}

export default observer(AddParticipantsToGroupForm);
